import React from 'react';
import AppHeader from 'anchor-ui/app-header';
import logo from '../../store/assets/logo.svg';
import ThemeProvider from 'anchor-ui/theme-provider';
import Button from '@material-ui/core/Button';
import {auth} from '../../firebase'
import * as routes from '../../constants/routes'
import {withRouter} from 'react-router-dom';
import AstrologerForm from '../AstrologerForm';

const styles = {
  HeaderLogo: {
    height: '60px',
    marginTop: '-5px',
    marginLeft: '-10px',
    paddingRight: '13px',
    //paddingTop: '2px',
    borderRight: '1px solid grey',
  },
  AppHeader: {
    backgroundColor: '#251447',
    height: '65px',
  },
  TextStyle : {
    color: '#EFF2EF',
    fontFamily: 'Arial',
  },
  Button: {
    fontFamily: 'Helvetica Neue',
    color: '#EFF2EF',
    //'backgroundColor': '#FFFFFF',
    paddingRight: '15px',
    marginTop: '6px',
  }
}

class Header extends React.Component{
  constructor(props) {
    super(props);
    this.toggleAstrologerForm = this.toggleAstrologerForm.bind(this)
    this.state = {
      formOpen: false
    }
  }

  handle_logout = () => {
    auth.doSignOut().then( () => {
      localStorage.removeItem('astrologerLoggedIn')
      setTimeout(()=>this.props.history.replace(routes.SIGN_IN)
      ,0)
    });
  }

  toggleAstrologerForm() {
    this.setState({formOpen: !this.state.formOpen})
  }

  render() {
    const {superadmin} = this.props
    return (
        <ThemeProvider color='#251447'>
          <AppHeader style={styles.AppHeader}
          text="Horas Admin Page"
          icon={<img src={logo} alt="Horace Chat" style={styles.HeaderLogo}/>}
          
          rightButton={
            superadmin? <div>
            <Button style={styles.Button} onClick={this.toggleAstrologerForm}>Add Astrologer</Button>
            <Button style={styles.Button} onClick={this.handle_logout}>Logout</Button>
            <AstrologerForm open={this.state.formOpen} handleFormClose={this.toggleAstrologerForm}/>
          </div>: <Button style={styles.Button} onClick={this.handle_logout}>Logout</Button>
          }
          textStyle={styles.TextStyle}
        />
        </ThemeProvider>

      );
  }
}


export default withRouter(Header)


// WEBPACK FOOTER //
// ./src/Components/Layouts/Header.js